import { useEffect } from 'react';
import { Plus, User } from 'lucide-react';
import DoctorBottomNav from './DoctorBottomNav';
import DoctorRecordFAB from './DoctorRecordFAB';
import { useDoctorSession } from '../contexts/DoctorSessionContext';
import { useLanguage } from '../../contexts/LanguageContext';

export default function DoctorShell({
  children,
  showFab = false,
  onFabClick,
  showMic = false,
  micPatientId = null,
  micPatientLabel = null,
}) {
  const { t } = useLanguage();
  const { toast, clearToast } = useDoctorSession();

  useEffect(() => {
    if (!toast) return undefined;
    const timer = window.setTimeout(() => clearToast(), 3000);
    return () => window.clearTimeout(timer);
  }, [toast, clearToast]);

  const spacer = showMic || showFab;

  return (
    <div className="min-h-screen bg-page">
      {children}
      {toast && (
        <div className="fixed left-4 right-4 top-4 z-[300] rounded-xl bg-primary px-4 py-3 text-sm font-semibold text-white shadow-lg">
          {toast.message}
        </div>
      )}
      <div aria-hidden="true" className={spacer ? 'h-safe-nav-fab shrink-0' : 'h-safe-nav shrink-0'} />
      {showMic && (
        <DoctorRecordFAB patientId={micPatientId} patientLabel={micPatientLabel} />
      )}
      {showFab && (
        <button
          type="button"
          data-tour="doctor-add-patient"
          onClick={onFabClick}
          className="fixed bottom-[calc(6.25rem+env(safe-area-inset-bottom,0px))] right-4 z-40 flex h-12 w-12 items-center justify-center rounded-full bg-primary text-white shadow-lg"
          aria-label={t('doctorAddPatient')}
        >
          <span className="relative flex h-7 w-7 items-center justify-center">
            <User className="h-5 w-5 -translate-x-0.5" strokeWidth={2.4} aria-hidden="true" />
            <Plus
              className="absolute -right-1 top-0 h-3.5 w-3.5"
              strokeWidth={2.75}
              aria-hidden="true"
            />
          </span>
        </button>
      )}
      <DoctorBottomNav />
    </div>
  );
}
